<template>
  <q-page padding>
    <PageHeader>
      <template #title> Detalhe Logs do Setup: {{ logId }} </template>
    </PageHeader>
    <div class="row text-brand-5 text-weight-bold q-mt-md">
      <div class="q-ml-sm col-md-2">
        Catalogo:
        <q-select
          v-model="statusFiltro"
          option-label="label"
          option-value="value"
          :options="listaStatus"
          dense
          map-options
          emit-value
          class="input-new-design"
          outlined
        />
      </div>
    </div>
    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo q-mt-md"
        :rows-per-page-options="[0]"
        hide-pagination
        row-key="name"
      >
        <template v-slot:top-right>
          <!--<q-input
                outlined
                rounded
                dense
                debounce="300"
                v-model="filter"
                placeholder="Filtrar por nome"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>-->
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Detalhes desse Log</span
          >
        </template>

        <template #body-cell-updated_at="props">
          <q-td>
            <div class="q-pl-sm">
              {{ props.row.updated_at }}
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="verLog">
      <q-card>
        <q-card-section> </q-card-section>

        <q-card-section class="q-pt-none">
          <vue-json-pretty :data="log" />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "dados",
    label: "Dados",
    field: "dados",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "mensagem",
    label: "Mensagem",
    field: "mensagem",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "nLinha",
    label: "Nº Linhas",
    field: "nLinha",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "sucesso",
    label: "Status",
    field: "sucesso",
    align: "left",
    style: "white-space: normal",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";
import VueJsonPretty from "vue-json-pretty";

import "vue-json-pretty/lib/styles.css";
import PageHeader from "../../../components/PageHeader.vue";
export default {
  components: { VueJsonPretty, PageHeader },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const statusFiltro = ref("todos");
    const unidade = ref();
    const quasar = useQuasar();
    const router = useRouter();
    const disable = ref(true);
    const route = useRoute();
    const logId = route.params.id;
    const verLog = ref(false);
    const log = ref(null);
    const logsQuantidade = ref(0);
    const catalogoEspecificoUuid = ref(null);

    const catalogoList = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async () => {
      try {
        let response = await store.dispatch("ferramentaria/logsSetupDetalhe", {
          logId: logId,
          sucesso: statusFiltro.value,
        });

        rows.value = response.data.resultado.dados;

        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        logsQuantidade.value = response.data.resultado.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const routeNotificacao = async () => {
      router.push({
        name: "configuracao-logs-lista-notificacao",
      });
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const receberCatalogoEspecifico = (value) => {
      catalogoEspecificoUuid.value = value;
    };

    const selecionarCatalogoEspecifico = async () => {
      try {
        const response = await store.dispatch("ferramentaria/listarCatalogo", {
          unidadeId: unidade.value?.id,
          page: 1,
          perPage: 10,
        });
        if (response.response.data.resultado?.dados.length == 0) {
          return;
        }
        catalogoList.value = response.response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(selecionarCatalogoEspecifico);

    const detalharLog = (logId) => {
      router.push({
        name: "log-setup-detalhe",
        params: { id: logId },
      });
    };

    watchDebounced(
      () => statusFiltro.value,
      () => {
        getDados();
      },
      { debounce: 400 },
      { deep: true }
    );
    return {
      rows,
      columns,
      getDados,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagination,
      disable,
      detalharLog,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      logsQuantidade,
      routeNotificacao,
      verLog,
      receberCatalogoEspecifico,
      log,
      listaStatus: [
        { label: "Todos", value: "todos" },
        { label: "Sucesso", value: "sucesso" },
        { label: "Erro", value: "erro" },
      ],
      logId,
      unidade,
      catalogoList,
      statusFiltro,
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}
</style>
